<template>
    
    <!-- Footer-->
    <footer class="footer bg-black small text-center text-white-50">
      <div class="container px-4 px-lg-5">
        Copyright &copy; CardanoKeys.com 2021
      </div>
    </footer>
</template>